import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { ReactNode } from 'react'
import { useAuth } from '../context/AuthContext'
import LoginPage from '../pages/LoginPage'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth()
  const isAuthDisabled = process.env.REACT_APP_DISABLE_AUTH === 'true'
  const hasJwtToken = localStorage.getItem('jwt_token') !== null

  if (isAuthDisabled) {
    return <>{children}</>
  }

  // If user has JWT token (custom auth), they're authenticated
  if (hasJwtToken && isAuthenticated) {
    return <>{children}</>
  }

  return (
    <>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
    </>
  )
}

export default ProtectedRoute
